import React, { useState } from 'react';
import { Modal } from 'antd';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import OWButton from '../ow_button/OWButton';
import ApproveEntityAddRequestModal from '../approve_entity_add_request_modal/ApproveEntityAddRequestModal';
import RejectEntityAddRequestModal from './RejectEntityAddRequestModal';
import EntityAddRequestDetails from './EntityAddRequestDetails';

function ReviewEntityAddRequestModal({ visible, record, hideModal, onSuccess }) {
	const [approveVisible, setApproveVisible] = useState(false);
	const [rejectVisible, setRejectVisible] = useState(false);

	const showApprove = () => setApproveVisible(true);
	const hideApprove = () => setApproveVisible(false);
	const showReject = () => setRejectVisible(true);
	const hideReject = () => setRejectVisible(false);

	const handleSubStepSuccess = () => {
		setApproveVisible(false);
		setRejectVisible(false);
		onSuccess();
		hideModal();
	};

	return (
		<>
			<Modal
				visible={visible && !approveVisible && !rejectVisible}
				width="80%"
				title={`Review Request: ${nullSafeGetOrElse('displayName', record, '')}`}
				onCancel={hideModal}
				closable={true}
				destroyOnClose={true}
				footer={[
					<OWButton key="reject" danger size="large" onClick={showReject}>
						Reject
					</OWButton>,
					<OWButton key="approve" type="primary" size="large" onClick={showApprove}>
						Approve
					</OWButton>,
				]}
			>
				<EntityAddRequestDetails record={record} />
			</Modal>
			{approveVisible ? (
				<ApproveEntityAddRequestModal
					visible={approveVisible}
					record={record}
					hideModal={hideApprove}
					onSuccess={handleSubStepSuccess}
				/>
			) : null}
			{rejectVisible ? (
				<RejectEntityAddRequestModal
					visible={rejectVisible}
					record={record}
					hideModal={hideReject}
					onSuccess={handleSubStepSuccess}
				/>
			) : null}
		</>
	);
}

export default ReviewEntityAddRequestModal;
